import type { DiceRequest } from '../domain/dice.ts';
import type { TableDie } from './raceDice.ts';

/**
 * THE ROLL FAMILIES THE ENGINE THROWS — presets for the `?dice-library` table.
 *
 * ⚠ THE OLD WHOLE-SCENE FOOTAGE (`public/dice-joint`, 157 MB, 2,040 clips) IS
 * GONE — 4 Oct 2026. It was selected only for these families, and every one of
 * them is drawn by another renderer first: one to three d6 (whatever their
 * colours — race cam, quality challenge, 11-66, 2d6, single dice) go to the
 * Baseball compositor, and all-d10 throws (d10, 2d10) go to the ivory d10
 * films (`d10Film.ts`, D-EZ-106).
 * `diceRenderer` in `WoodenDice.tsx` is the dispatcher and `jointDice.test.ts`
 * proves, for every notation the engine emits, that no throw reached the old
 * footage. A throw no renderer animates (four or more d6, mixed sides) shows
 * its exact faces as a still, which is what the old path did anyway when no
 * clip existed for it.
 */
export const JOINT_TAKES = 3;
export const JOINT_FAMILIES = [
  ...['metallic', 'white', 'black', 'red', 'blue'].map(role => ({
    id: `single6-${role}`, sides: 6, roles: [role], label: `${role.charAt(0).toUpperCase() + role.slice(1)} die`,
  })),
  { id: 'sum6', sides: 6, roles: ['metallic', 'metallic'], label: 'Two metallic dice · sum' },
  { id: 'code6', sides: 6, roles: ['red', 'white'], label: 'Red and white · chart lookup' },
  { id: 'cam-pair', sides: 6, roles: ['black', 'metallic'], label: 'Race cam · two faces entered by hand' },
  { id: 'cam', sides: 6, roles: ['black', 'metallic', 'metallic'], label: 'Race cam · black and two metallic' },
  { id: 'challenge', sides: 6, roles: ['red', 'white', 'blue'], label: 'Challenge · red, white and blue' },
  { id: 'single10', sides: 10, roles: ['metallic'], label: 'One ten-sided die' },
  { id: 'sum10', sides: 10, roles: ['metallic', 'metallic'], label: 'Two ten-sided dice · sum' },
] as const;

/** Preserve the shape and roles of faces already entered in a manual throw. */
export function enteredTableDice(request:DiceRequest):TableDie[]{
  return request.given.map((face,i)=>({face,sides:request.sides,role:request.roles[i]&&!['first','second'].includes(request.roles[i])?request.roles[i]:'metallic'}));
}
